var render, staticRenderFns
var script = {}
import style0 from "./Errors.vue?vue&type=style&index=0&id=39ae231a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports